/**
 * Can be used by some plugins to have a "global" object that
 * can be imported and mutated at will.
 */
export const RXDB_UTILS_GLOBAL: any = {};
